export interface ComplexSelectItem {
  label: string;
  value: any;
  url?: string;
}
